/* eslint-disable @typescript-eslint/naming-convention */
import { isMobile } from 'react-device-detect'
import ReactGA from 'react-ga4'

export const initializeAnalytics = () => {
  const GOOGLE_ANALYTICS_ID: string | undefined =
    process.env.REACT_APP_GA_MEASUREMENT_ID
  if (typeof GOOGLE_ANALYTICS_ID === 'string' && GOOGLE_ANALYTICS_ID) {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID)
    ReactGA.set({
      customBrowserType: !isMobile
        ? 'desktop'
        : 'web3' in window || 'ethereum' in window
        ? 'mobileWeb3'
        : 'mobileRegular'
    })
    ReactGA.send('pageview')
  } else {
    ReactGA.initialize('test', { testMode: true })
  }
}

export const trackReportFakeCollection = (): void =>
  ReactGA.event('report_fake_collection', {
    event_category: 'user_report'
  })

export const trackTransferNftFromItemDetailPage = (
  collectionName: string
): void =>
  ReactGA.event('transfer_nft_from_item_detail_page', {
    event_category: 'item_detail_page',
    event_label: collectionName
  })

export const trackMint = (id: string, quantity: number): void =>
  ReactGA.event('mint', { event_category: id, quantity })

export const trackHideItems = (): void => ReactGA.event('hide_nft')
